import { render, staticRenderFns } from "./addTaxpayer.vue?vue&type=template&id=3e20db0f&scoped=true&"
import script from "./addTaxpayer.vue?vue&type=script&lang=js&"
export * from "./addTaxpayer.vue?vue&type=script&lang=js&"
import style0 from "./addTaxpayer.vue?vue&type=style&index=0&id=3e20db0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20db0f",
  null
  
)

export default component.exports